import general from './kg_general'
import header from './kg_header'
import sidebar from './kg_sidebar'
import calendar from './kg_calendar'
import warehouses from './kg_warehouses'
import patients from "./kg_patients"
import settings from "./kg_settings"
import services from "./kg_services"
import staff from "./kg_staff"
import accounting from "./kg_accounting"
import reports from "./kg_reports"
import templates from "./kg_templates"
import cashdesk from "./kg_cashdesk"
import planning from "./kg_planning"
import crm from "./kg_crm"
import egisz from "./kg_egisz"
import marketing from "./kg_marketing"
import insurance from "./kg_insurance"
import tags from "./kg_tags"
import referral from "./kg_referral"
import laboratories from "./kg_laboratories"
import documents from "./kg_documents"
import profile from "./kg_profile"
import telegram from "./kg_telegram"
import market from "./kg_market"
import legal from "./kg_legal"
import nontranslated from "./kg_nontranslated"

export default {
    ...general,
    ...header,
    ...sidebar,
    ...calendar,
    ...warehouses,
    ...patients,
    ...services,
    ...staff,
    ...accounting,
    ...reports,
    ...templates,
    ...cashdesk,
    ...planning,
    ...settings,
    ...crm,
    ...egisz,
    ...marketing,
    ...insurance,
    ...tags,
    ...referral,
    ...laboratories,
    ...documents,
    ...profile,
    ...telegram,
    ...market,
    ...legal,
    ...nontranslated
}
